import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import AssignmentIcon from '@material-ui/icons/Assignment'; // Başlık ikon için eklendi
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 16,
    overflow: 'hidden', // Header köşelerinin taşmasını engeller
    maxWidth: 500,
    width: '100%'
  },
  headerContainer: {
    backgroundColor: '#FF6000',
    color: '#ffffff',
    padding: theme.spacing(2.5, 3),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: '18px',
    display: 'flex',
    color: 'white',
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: '24px'
    }
  },
  titleText: {
    fontWeight: 600,
    fontSize: '15.5px',
    color: '#333333',
    marginBottom: theme.spacing(2.5),
    lineHeight: 1.5
  },
  formGroup: {
    gap: theme.spacing(1.5) // Seçenekler arası boşluk
  },
  checkboxCard: {
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    padding: theme.spacing(0.5, 2),
    backgroundColor: '#F9F9F9',
    transition: 'all 0.2s ease-in-out',
    margin: '0 !important', // FormGroup default margin sıfırlama
    width: '100%',
    '&:hover': {
      backgroundColor: '#F0F0F0',
      borderColor: '#BDBDBD'
    }
  },
  checkboxCardSelected: {
    border: '1px solid #FF6000',
    backgroundColor: '#FFF9F5',
    '&:hover': {
      backgroundColor: '#FFF1E7'
    }
  },
  checkboxLabel: {
    fontWeight: 500,
    fontSize: '14.5px',
    color: '#4F4F4F'
  },
  checkboxLabelSelected: {
    color: '#000000',
    fontWeight: 600
  },
  otherTextField: {
    marginTop: theme.spacing(1),
    width: '100%'
  },
  actions: {
    padding: theme.spacing(2, 3, 3, 3),
    display: 'flex',
    justifyContent: 'center'
  },
  submitButton: {
    backgroundColor: '#FF6000',
    color: '#ffffff',
    fontWeight: 'bold',
    borderRadius: 25, // Tam yuvarlak buton tasarımı (image_c77936.png ile uyumlu)
    padding: theme.spacing(1.5, 6),
    fontSize: '15px',
    textTransform: 'none',
    boxShadow: '0px 4px 10px rgba(255, 96, 0, 0.3)',
    '&:hover': {
      backgroundColor: '#E65500',
      boxShadow: '0px 6px 14px rgba(255, 96, 0, 0.4)'
    },
    '&:disabled': {
      backgroundColor: '#CCCCCC',
      color: '#666666',
      boxShadow: 'none'
    }
  }
}));

const ExtraWarrantySurveyPopup = ({ open, onClose }) => {
  const classes = useStyles();
  const SessionUser = getUser();
  const teknisyenKodu = SessionUser?.TechnicianId?.toString() || '';

  const [selectedOptions, setSelectedOptions] = useState({
    option1: false,
    option2: false,
    option3: false,
    option4: false
  });
  const [otherText, setOtherText] = useState('');

  const handleCheckboxChange = event => {
    setSelectedOptions({
      ...selectedOptions,
      [event.target.name]: event.target.checked
    });
  };

  const handleOtherTextChange = event => {
    const value = event.target.value;
    if (value.length <= 160) {
      setOtherText(value);
    }
  };

  const isAnyOptionSelected = () => {
    return Object.values(selectedOptions).some(value => value === true);
  };

  const handleSubmit = () => {
    if (!isAnyOptionSelected()) {
      return;
    }
    const selectedList = [
      selectedOptions.option1 && 'Müşteri ilgilenmedi',
      selectedOptions.option2 && 'Zamanım yoktu / işlem yoğundu',
      selectedOptions.option3 && 'Nasıl teklif edeceğimi bilmiyorum',
      selectedOptions.option4 && 'Diğer'
    ].filter(Boolean);

    const description =
      selectedList.join(', ') +
      (selectedOptions.option4 && otherText ? ` - ${otherText}` : '');
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post(
        'SetArtemisEkGarantiAnket',
        {
          TechnicianCode: teknisyenKodu,
          Desc: description
        },
        config
      )
      .then(response => {
        onClose();
      })
      .catch(error => {
        console.error('Anket gönderilirken hata:', error);
        onClose();
      });
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="extra-warranty-survey-title"
      classes={{ paper: classes.dialogPaper }}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
    >
      {/* YENİ HEADER ALANI */}
      <DialogTitle disableTypography className={classes.headerContainer}>
        <Typography variant="h6" className={classes.headerTitle}>
          <AssignmentIcon /> Ek Garanti Anketi
        </Typography>
      </DialogTitle>

      <DialogContent style={{ padding: '24px' }}>
        <Typography variant="body1" className={classes.titleText}>
          Gün içerisinde ek garanti teklifi yapmadığın işlerin vardı. Neden
          teklif edemedin?
        </Typography>

        <FormGroup className={classes.formGroup}>
          {/* Seçenek 1 */}
          <FormControlLabel
            className={`${classes.checkboxCard} ${
              selectedOptions.option1 ? classes.checkboxCardSelected : ''
            }`}
            control={
              <Checkbox
                checked={selectedOptions.option1}
                onChange={handleCheckboxChange}
                name="option1"
                style={{
                  color: selectedOptions.option1 ? '#FF6000' : '#757575'
                }}
              />
            }
            label={
              <Typography
                className={`${classes.checkboxLabel} ${
                  selectedOptions.option1 ? classes.checkboxLabelSelected : ''
                }`}
              >
                Müşteri ilgilenmedi
              </Typography>
            }
          />

          {/* Seçenek 2 */}
          <FormControlLabel
            className={`${classes.checkboxCard} ${
              selectedOptions.option2 ? classes.checkboxCardSelected : ''
            }`}
            control={
              <Checkbox
                checked={selectedOptions.option2}
                onChange={handleCheckboxChange}
                name="option2"
                style={{
                  color: selectedOptions.option2 ? '#FF6000' : '#757575'
                }}
              />
            }
            label={
              <Typography
                className={`${classes.checkboxLabel} ${
                  selectedOptions.option2 ? classes.checkboxLabelSelected : ''
                }`}
              >
                Zamanım yoktu / işlem yoğundu
              </Typography>
            }
          />

          {/* Seçenek 3 */}
          <FormControlLabel
            className={`${classes.checkboxCard} ${
              selectedOptions.option3 ? classes.checkboxCardSelected : ''
            }`}
            control={
              <Checkbox
                checked={selectedOptions.option3}
                onChange={handleCheckboxChange}
                name="option3"
                style={{
                  color: selectedOptions.option3 ? '#FF6000' : '#757575'
                }}
              />
            }
            label={
              <Typography
                className={`${classes.checkboxLabel} ${
                  selectedOptions.option3 ? classes.checkboxLabelSelected : ''
                }`}
              >
                Nasıl teklif edeceğimi bilmiyorum
              </Typography>
            }
          />

          {/* Seçenek 4 */}
          <FormControlLabel
            className={`${classes.checkboxCard} ${
              selectedOptions.option4 ? classes.checkboxCardSelected : ''
            }`}
            control={
              <Checkbox
                checked={selectedOptions.option4}
                onChange={handleCheckboxChange}
                name="option4"
                style={{
                  color: selectedOptions.option4 ? '#FF6000' : '#757575'
                }}
              />
            }
            label={
              <Typography
                className={`${classes.checkboxLabel} ${
                  selectedOptions.option4 ? classes.checkboxLabelSelected : ''
                }`}
              >
                Diğer
              </Typography>
            }
          />

          {/* "Diğer" seçildiğinde açılan input alanı */}
          {selectedOptions.option4 && (
            <Box className={classes.otherTextField}>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                placeholder="Lütfen açıklayınız (İsteğe bağlı, max 160 karakter)"
                value={otherText}
                onChange={handleOtherTextChange}
                helperText={`${otherText.length}/160`}
                InputProps={{
                  style: { borderRadius: 8 }
                }}
              />
            </Box>
          )}
        </FormGroup>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button
          variant="contained"
          className={classes.submitButton}
          onClick={handleSubmit}
          disabled={!isAnyOptionSelected()}
        >
          GÖNDER
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExtraWarrantySurveyPopup;
